import { Link } from "react-router-dom";

export const Overline = ({ children, className = "" }) => (
  <span className={`overline ${className}`}>{children}</span>
);

export const PrimaryButton = ({ to, onClick, children, testid, type = "button", disabled }) => {
  const cls =
    "inline-flex items-center justify-center bg-brand-olive text-brand-cream px-8 py-4 font-sans uppercase tracking-[0.18em] text-xs hover:bg-brand-charcoal transition-colors duration-500 disabled:opacity-50";
  if (to) return <Link to={to} data-testid={testid} className={cls}>{children}</Link>;
  return <button type={type} data-testid={testid} onClick={onClick} disabled={disabled} className={cls}>{children}</button>;
};

export const GhostButton = ({ to, onClick, children, testid }) => {
  const cls =
    "inline-flex items-center justify-center bg-transparent border border-brand-gold text-brand-charcoal px-8 py-4 font-sans uppercase tracking-[0.18em] text-xs hover:bg-brand-linen transition-colors duration-500";
  if (to) return <Link to={to} data-testid={testid} className={cls}>{children}</Link>;
  return <button data-testid={testid} onClick={onClick} className={cls}>{children}</button>;
};

export const SectionHeading = ({ overline, title, sub, center, className = "" }) => (
  <div className={`${center ? "text-center mx-auto" : ""} max-w-2xl ${className}`}>
    {overline && <Overline>{overline}</Overline>}
    <h2 className="text-4xl sm:text-5xl lg:text-6xl font-light leading-tight mt-4 mb-5">{title}</h2>
    {sub && <p className="font-body text-brand-body text-lg leading-relaxed">{sub}</p>}
  </div>
);
